<template>
  <div class="profile-wrapper">
    <div class="data-wrapper">
      <div class="image-wrapper">
        <img :src="`${baseUrl}${member.profile_pic_URL.link}`" alt />
      </div>
      <div class="info-wrapper">
        <div class="basic-info">
          <label>
            <h4>Prezime i ime</h4>
          </label>
          <h5>{{ member.full_name }}</h5>
          <br />
          <label>
            <h4>Opis</h4>
          </label>
          <h5>{{ member.div_desc }}</h5>
        </div>
        <div class="common-communities">
          <label>
            <h4>Zajedničke zajednice</h4>
          </label>
          <p
            :class="{ 'mod--par': isAdministrated(c.community_id) }"
            v-for="c in commonCommunities"
            :key="c.community_id"
            @click="openCommunityCards(c.community_id)"
          >
            {{
              c.address_name +
                ' ' +
                c.street_number +
                ', ' +
                c.municipality.name
            }}
          </p>
        </div>
      </div>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn btn-danger btn--mod" @click="closeModal">Nazad</button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      commonCommunities: [],
      baseUrl: ''
    };
  },
  computed: {
    ...mapState('modal', ['member'])
  },
  created() {
    this.getMemberDetails();
    //postavljanje baseUrl za slicicu
    this.baseUrl = process.env.VUE_APP_OBJECT_STORAGE_URL;
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapMutations(['setActiveCommunity', 'setUser']),

    openCommunityCards(id) {
      if (!this.isAdministrated(id)) {
        return;
      }

      this.setActiveCommunity(id);
      this.closeModal();
      this.$router.push({
        name: 'community',
        params: {
          id: id
        }
      });
    },
    isAdministrated(communityId) {
      for (let community of this.$store.state.communities.communities) {
        if (community.community_id === communityId) {
          return true;
        }
      }
      return false;
    },
    getMemberDetails() {
      axios
        .post('member/get-member-info', {
          member_id: this.member.id
        })
        .then(({ data }) => {
          this.commonCommunities = data.common_communities;
        })
        .catch(err => {
          console.log(err);
          this.closeModal();
          this.showModal('ModalErrorMessage');
        });
    }
  }
};
</script>

<style scoped lang="scss">
.data-wrapper {
  text-align: left;
  display: inline-flex;
  justify-content: center;
  label {
    margin-bottom: 0px;
  }
  margin-bottom: 30px;
}
.info-wrapper {
  margin-left: 25px;
  display: inline-flex;
  label {
    color: var(--primary-color);
  }
}
.basic-info,
.common-communities {
  margin-left: 20px;
  width: 100%;
  p {
    margin-top: 0px;
    margin-bottom: 1px;
  }
}

img {
  height: 200px;
  width: 200px;
  object-fit: cover;
  border-radius: 50%;
}

.image-wrapper {
  height: 200px;
  width: 200px;
  /*overflow: hidden;*/
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
}
.modal-footer {
  justify-content: center;
  align-items: center;
  display: flex;
}

.mod--par:hover {
  color: var(--primary-color);
  cursor: pointer;
}
</style>
